interface FieldErrorProps {
  error?: string;
}

/**
 * Displays a field-level validation error message
 * Used to show inline errors below form inputs
 */
export function FieldError({ error }: FieldErrorProps) {
  if (!error) return null;

  return (
    <p className="mt-1 text-sm text-red-600" role="alert">
      {error}
    </p>
  );
}
